module.exports = __webpack_public_path__ + "img/bcity.d0d97679.jpg";